export class ZeroDollarCheckDeposit {
    constructor(
        public Payer_ShardPayerIdentifier: string,
        public Check_CheckNumber: string,
        public Deposit_DepositDate?: Date,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/models/zerodollarcheckdeposit.model.ts